import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'default' | 'small';
}

export default function ComicCard({ comic, size = 'default' }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-100 ${
        size === 'small' ? 'aspect-[3/4]' : 'aspect-[5/7]'
      }`}>
        <img
          src={comic.coverImage}
          alt={`${comic.title} - 布丁漫画下拉式免费阅读`}
          title={`${comic.title} | 布丁漫画下拉式漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <p className="text-xs text-background-50 line-clamp-2">{comic.description.slice(0, 60)}...</p>
        </div>
        {comic.status === '连载中' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded-full">
            连载
          </span>
        )}
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium bg-secondary-500 text-background-50 rounded-full">
            完结
          </span>
        )}
        <div className="absolute top-2 right-2 flex items-center gap-0.5 px-1.5 py-0.5 rounded-full bg-foreground-950/60 text-accent-400">
          <span className="w-3 h-3 flex items-center justify-center">
            <i className="ri-star-fill text-[10px]"></i>
          </span>
          <span className="text-[10px] font-medium">{comic.rating}</span>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="text-[10px] text-foreground-300">·</span>
          <span className="text-xs text-foreground-400">{comic.category}</span>
        </div>
        {size === 'default' && (
          <div className="flex items-center gap-3 mt-1.5">
            <span className="text-[10px] text-foreground-400">共{comic.chapters}话</span>
            <span className="text-[10px] text-foreground-400">{comic.views}阅读</span>
          </div>
        )}
      </div>
    </Link>
  );
}